import { Typography } from 'antd'
import SellingPrice from '../../../../components/editable-cell/form-items/selling-price'
import { onAnyStandardCell } from '../../helpers/helpers'
import isCalculation from '../../helpers/is-calculation'
import type { CalculationColumn } from '../../types/column-types'
import { blue } from '@ant-design/colors'

export const sellingPriceColumn: CalculationColumn = {
    dataIndex: 'sellingPrice',
    title: 'Отп. цена',
    width: 50,
    editable: true,
    FormItem: <SellingPrice />,
    render(value, record, index) {
        return <Typography.Text strong>{value}</Typography.Text>
    },
    onHeaderCell: () => ({
        style: {
            backgroundColor: blue[1],
        },
    }),
    onCell: record => ({
        ...onAnyStandardCell(record),
        editable: isCalculation(record) || record.shipmentType !== 'colorProof',
        style: { backgroundColor: blue[1] },
    }),
}
